module.exports = __webpack_public_path__ + "media/images/icons/camera-slr-dbe24aecb838c307f0d76b1ee1aca7fb.svg";